import { render, staticRenderFns } from "./StacBond.vue?vue&type=template&id=0cd72aac&scoped=true"
import script from "./StacBond.vue?vue&type=script&lang=js"
export * from "./StacBond.vue?vue&type=script&lang=js"
import style0 from "./StacBond.vue?vue&type=style&index=0&id=0cd72aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd72aac",
  null
  
)

export default component.exports